"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _get = _interopRequireDefault(require("lodash/get"));

var _util = require("../util");

var _Scaffold = _interopRequireDefault(require("../Scaffold"));

var _without = _interopRequireDefault(require("lodash/without"));

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getBackgroundColor(theme, props) {
  try {
    if ((0, _util.checkString)(props.color)) {
      return theme.colors[props.color]["500"];
    } else {
      if ((0, _color["default"])(props.color)) {
        return props.color;
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(err);
    return theme.colors.black;
  }
}

function getSpanColor(theme, props) {
  var backgroundColor;

  if ((0, _util.checkString)(props.color)) {
    backgroundColor = theme.colors[props.color]["500"];
  } else {
    backgroundColor = props.color;
  }

  if ((0, _color["default"])(backgroundColor).isDark()) {
    return theme.colors["white"];
  } else if ((0, _color["default"])(backgroundColor).isLight()) {
    return theme.colors["gray900"];
  } else {
    return theme.colors["gray600"];
  } // // if (Color(background).isDark()) {
  // //   return theme.colors.white;
  // // } else {
  // //   return theme.colors.gray900;
  // // }

}
/**
 * A component used to render a group of buttons that can have a single or multiple values.
 */


var ButtonGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ButtonGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      var _this$props = _this.props,
          _this$props$field = _this$props.field,
          name = _this$props$field.name,
          value = _this$props$field.value,
          setFieldValue = _this$props.form.setFieldValue;
      var selectedButton = e.target.id;

      if (_this.props.multiSelect) {
        var selectedButtons = Array.isArray(value) ? value.slice() : [];

        if (e.target.checked && selectedButtons.indexOf(selectedButton) === -1) {
          selectedButtons.push(selectedButton);
        } else if (!e.target.checked) {
          selectedButtons = (0, _without["default"])(selectedButtons, selectedButton);
        }

        return setFieldValue(name, selectedButtons);
      } else {
        if (value === selectedButton) {
          return setFieldValue(name, "");
        }

        return setFieldValue(name, selectedButton);
      }
    });

    return _this;
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          _this$props2$field = _this$props2.field,
          name = _this$props2$field.name,
          value = _this$props2$field.value,
          _this$props2$form = _this$props2.form,
          errors = _this$props2$form.errors,
          touched = _this$props2$form.touched,
          values = _this$props2$form.values,
          items = _this$props2.items,
          label = _this$props2.label,
          multiSelect = _this$props2.multiSelect;
      return _react["default"].createElement(_Scaffold["default"], {
        label: label,
        error: (0, _get["default"])(touched, name) && (0, _get["default"])(errors, name)
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.toggles, classes.inline)
      }, items.map(function (item) {
        var input = item.value;
        return _react["default"].createElement(_react.Fragment, {
          key: item.value
        }, _react["default"].createElement("label", {
          className: (0, _classnames["default"])(classes.button, Array.isArray(values[name]) ? values[name].includes(item.value) ? classes.buttonActive : null : values[name] === item.value ? classes.buttonActive : null)
        }, _react["default"].createElement("span", null, item.label), _react["default"].createElement("input", {
          id: item.value,
          type: "checkbox",
          name: name,
          className: classes.hiddenInput,
          checked: multiSelect ? value.indexOf(item.value) > -1 : value === item.value,
          value: item.value,
          onChange: _this2.onChange,
          ref: function ref(node) {
            return _this2["input".concat(item.value)] = node;
          }
        })));
      })));
    }
  }]);

  return ButtonGroup;
}(_react.Component);

_defineProperty(ButtonGroup, "defaultProps", {
  items: [],
  multiSelect: false,
  color: "primary"
});

var styles = function styles(theme) {
  return {
    toggles: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      alignItems: "flex-start",
      width: "100%"
    },
    inline: {
      flexDirection: "row"
    },
    hiddenInput: {
      display: "none"
    },
    button: {
      background: "#fff",
      border: "1px solid ".concat(theme.colors["gray300"]),
      borderRight: "none",
      padding: 12,
      cursor: "pointer",
      "&:first-of-type": {
        borderLeft: "1px solid ".concat(theme.colors["gray300"]),
        borderTopLeftRadius: theme.globalBorderRadius,
        borderBottomLeftRadius: theme.globalBorderRadius
      },
      "&:last-of-type": {
        borderRight: "1px solid ".concat(theme.colors["gray300"]),
        borderTopRightRadius: theme.globalBorderRadius,
        borderBottomRightRadius: theme.globalBorderRadius
      },
      "& span": {
        pointerEvents: "none",
        color: theme.colors["gray600"]
      }
    },
    buttonActive: {
      background: function background(props) {
        return getBackgroundColor(theme, props);
      },
      border: "1px solid ".concat(theme.colors["gray300"]),
      borderRight: "none",
      padding: 12,
      cursor: "pointer",
      "&:first-of-type": {
        borderLeft: "1px solid ".concat(theme.colors["gray300"]),
        borderTopLeftRadius: theme.globalBorderRadius,
        borderBottomLeftRadius: theme.globalBorderRadius
      },
      "&:last-of-type": {
        borderRight: "1px solid ".concat(theme.colors["gray300"]),
        borderTopRightRadius: theme.globalBorderRadius,
        borderBottomRightRadius: theme.globalBorderRadius
      },
      "& span": {
        color: function color(props) {
          return getSpanColor(theme, props);
        }
      }
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiButtonGroup"
})(ButtonGroup);

exports["default"] = _default;